import { render } from "./HomeNavBar.vue?vue&type=template&id=0b4879c4&scoped=true"
import script from "./HomeNavBar.vue?vue&type=script&lang=js"
export * from "./HomeNavBar.vue?vue&type=script&lang=js"

import "./HomeNavBar.vue?vue&type=style&index=0&id=0b4879c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4879c4"]])

export default __exports__